import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  items: [], // { productId, quantity }
};

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    addItem: (state, action) => {
      const { productId, quantity, userCommentAnswer = null } = action.payload; // { productId, quantity, comment }
      const existing = state.items.find((i) => i.productId === productId);
      if (existing) {
        existing.quantity = quantity; // עדכון הכמות
        if (userCommentAnswer) {
          existing.userCommentAnswer = userCommentAnswer; // עדכון התגובה אם ניתנה
        }
      } else {
        if (userCommentAnswer) {
          state.items.push({ productId, quantity, userCommentAnswer });
        } else {
          state.items.push({ productId, quantity }); // הוספת פריט חדש ללא הערה אם לא ניתנה
        }
      }
    },
    updateQuantity: (state, action) => {
      const { productId, quantity } = action.payload;
      const item = state.items.find((i) => i.productId === productId);
      if (item) {
        item.quantity = Math.max(0, quantity);
      }
    },
    removeItem: (state, action) => {
      const productId = action.payload;
      state.items = state.items.filter((i) => i.productId !== productId);
    },
    clearCart: (state) => {
      state.items = [];
    },
  },
});

export const { addItem, updateQuantity, removeItem, clearCart } =
  cartSlice.actions;
export const selectCartItems = (state) => state.cart.items;
export default cartSlice.reducer;
